"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/es/select/style");
var _select = _interopRequireDefault(require("antd/es/select"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
//default befaviour should be to allow search by default unless overriden in specifc app
let showSearch = true;
let sortOptions = true;
const SelectComponent = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  var children = props.children;
  if (props.children && props.sortOptions === undefined || props.sortOptions === true) {
    try {
      children = orderListByKey([...children]);
    } catch (err) {
      console.warn("Failed to apply default sort :", err);
      children = props.children;
    }
  } else children = props.children;
  return /*#__PURE__*/_react.default.createElement(_select.default, _extends({
    ref: ref,
    showSearch: showSearch,
    filterOption: (input, option) => option.props.children && option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
  }, props, {
    children: children
  }));
});
function orderListByKey(data) {
  const compareValues = (elemA, elemB) => {
    if (!elemA || !elemB || !elemA.props || !elemB.props || !elemA.props.children || !elemB.props.children || typeof elemA.props.children !== "string" || typeof elemB.props.children !== "string") return 0;
    const comparison = elemA.props.children.localeCompare(elemB.props.children);
    return comparison;
  };
  return data.sort(compareValues);
}
SelectComponent.Option = _select.default.Option;
var _default = exports.default = SelectComponent;